import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";


export const isSatisfactionSurveyAvailable = (workItemId, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/customer-satisfaction-survey/${workItemId}/available`,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });    
};

export const setSatisfactionSurvey = (workItemId, payload, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/customer-satisfaction-survey/${workItemId}`,
    payload: payload,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });
};

export const getSatisfactionSurvey = (controlNumber, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/customer-satisfaction-survey/${controlNumber}`,
    successCallback: successCallback,
    errorCallback: errorCallback,
    mountedRef: mountedRef,
  });
};